import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './iframe.scss';
import closeButton from '../../../../src/assets/images/close_icon.svg';
import { useNavigate } from 'react-router-dom';
import Log from '../../../Services/Log';

// Reusable Iframe component
const Iframe = ({ src, width, height, title, onPaymentStatus, resetStatus }) => {
    const [iframeClose, setIframeClose] = useState(false);
    const [iframeReset, setIframeReset] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (iframeReset) {
            resetStatus(true);
        }
    }, [iframeReset, resetStatus]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== "https://mercury-uat.phonepe.com") return;

            try {
                const decodedData = atob(event.data);
                const jsonData = JSON.parse(decodedData);

                if (jsonData.bridgeContext && jsonData.bridgeContext.code) {
                    onPaymentStatus(jsonData.bridgeContext.code); 
                    Log('payment status' , 'info' , jsonData.bridgeContext.code)
                    switch (jsonData.bridgeContext.code) {
                        case 'CONCLUDED':
                            alert('Payment successful');
                            navigate('/live-ads')
                            break;
                        case 'USER_CANCEL':
                            alert('Payment cancel');
                            window.location.href = '/payment-status?status=Failed';
                            break;
                        default:
                            alert(`Payment ${jsonData.bridgeContext.code}`);
                            window.location.href = `/payment-status?status=${jsonData.bridgeContext.code}`;
                            break;
                    }
                }
            } catch (error) {
                console.error('Error processing payment message:', error);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [onPaymentStatus]);

    if (!src) {
        return <p>No source provided</p>;
    }

    return (
        <div className={`iframe-container ${iframeClose ? 'closed' : 'active'} `}>
            <div className="iframe_wrapper">
                {/* <button
                    className="dflt_btn_removed close-button"
                    onClick={() => {
                        setIframeClose((prev) => !prev);
                        setIframeReset(true)
                        navigate('/live-ads')
                    }}
                >
                    <img src={closeButton} alt="Close iframe" />
                </button> */}
                
                <iframe
                    className="payment_frame"
                    src={src}
                    width={width}
                    height={height}
                    title={title}
                    frameBorder="0"
                    style={{ border: 'none', height: '800px', pointerEvents: 'auto' }}
                />
            </div>
        </div>
    );
};

// Prop validation
Iframe.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    title: PropTypes.string,
    onPaymentStatus: PropTypes.func.isRequired,
    resetStatus: PropTypes.func.isRequired,
};

// Default props
Iframe.defaultProps = {
    width: '400px',
    height: '800px',
    title: 'Iframe',
};

export default Iframe;
